import Lazyload from 'vue-lazyload';
export default Lazyload;


//////////////////
// WEBPACK FOOTER
// ./~/_vant@2.12.54@vant/es/lazyload/index.js
// module id = 1019
// module chunks = 41